import { Message } from "element-ui";
import axios, { officialId, baseUrl, $asyncGet, $asyncPost } from "./common";

// axios.defaults.baseURL = "https://test-api.hakspay.cn/";
axios.defaults.headers.post["Content-Type"] = "application/json";

/** 获取微信会员卡信息
 *  datas内容
 * v3/wxHelper/card/query
 *  "describe": "string",
 *  "classify_no": "string",
 *  "classify_name": "string",
 *  "parent_classify_no": "string"
 */
export const wxServiceMembershipQuery = async function (
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  var data = {
    appid,
    data: {
      card_id
    }
  };
  try {
    return await axios.post("v3/wxHelper/card/query", JSON.stringify(data));
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 修改会员卡信息
 * /v3/wxHelper/card/set
 */
export const wxServiceMembershipSet = async function (
  datas,
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  var data = {
    appid,
    data: {
      card_id,
      member_card: {
        ...datas
      }
    }
  };
  try {
    return await axios.post("v3/wxHelper/card/set", JSON.stringify(data));
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 设置开卡填写内容
 * /v3/wxHelper/ card/SetActiveFormData
 */
export const wxServiceCardSetActiveFormData = async function (
  datas,
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  var data = {
    appid,
    data: {
      card_id,
      ...datas
    }
  };
  try {
    return await axios.post(
      "v3/wxHelper/card/SetActiveFormData",
      JSON.stringify(data)
    );
  } catch (e) {
    Message.error(e);
  }
};

/**
 * /v3/wxHelper/ticket/generateqrcode
 * 生成二维码
 */
export const wxServiceGenerateqrcode = async function (
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  const outer_id = localStorage.getItem("token_type") === "service" ? "2" : "1";
  var data = {
    appid,
    data: {
      action_name: "QR_CARD",
      action_info: {
        card: {
          card_id,
          outer_str: outer_id === "2" ? localStorage.getItem("service_no") : localStorage.getItem("merchant_id"),
          outer_id
        }
      }
    }
  };
  console.log(JSON.stringify(data));
  try {
    return await axios.post(
      "v3/wxHelper/ticket/generateqrcode",
      JSON.stringify(data)
    );
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 通过公众号appid 获取公众号创建的 微信会员卡
 * @param {"wx59275b1f7f83e45f"|"wxf003ddc051b4643b"} appid 公众号的appid wx59275b1f7f83e45f - 测试公众号 wxf003ddc051b4643b - 淮安快刷
 */
/* export const wxServiceGetCardList = async function (appid) {
  try {
    return new Promise((resovle, reject) => {
      axios.get(`v3/wxHelper/card/list?appid=${appid}`).then(res => {
        if (res.data && res.data.resp_data && res.data.resp_data.card_id_list) {
          resovle(res.data.resp_data.card_id_list);
        } else {
          reject(false);
        }
      });
    })
  } catch (e) {
    Message.error(e);
  }
} */

/**
 * 获取店铺关注链接
 */
export const getAttention = function (token_type) {
  const mch_no = localStorage.getItem("merchant_id");
  let url = "v3/wxHelper/Qr/MerchantAttention" + `${token_type === 'account' ? '?mch_no=' + mch_no : ''}`;
  return axios.get(url)
};

/**
 * 获取小程序跳转链接
 */
export const getMiniQrcode = function () {
  return `${baseUrl}/v3/wxHelper/card/GetUserOpenID?mch_no=${localStorage.getItem("merchant_id")}`
}
/**
 * 跳转到微信小程序
 * @param {*} mch_no
 * @param {*} env
 * @param {*} path
 * @returns
 */
export const goWxMiniProgram = function (mch_no, env, path) {
  return `${baseUrl}/v3/wxHelper/card/RedirectProgram?mch_no=${mch_no}&env=${env}&path=${path}`;
}

/**
 * 用户登录
 * @param {*} code 获取到的code
 * @returns
 */
export const wxGetAcToken = function (code) {
  return axios.get(`v3/wxHelper/login/GetLoginAccessToken?code=${code}`);
}

/**
 * 查询支持的对公银行
 * v3/ServiceProvider/Pay/QueryCorporateBanks
 */
export const queryCorporateBanks = function () {
  return $asyncGet(`v3/ServiceProvider/Pay/QueryCorporateBanks?service_no=${localStorage.getItem("service_no")}`);
}

/**
 * 查询支持的对私银行
 * v3/ServiceProvider/Pay/QueryPersonBanks
 */
export const queryPersonBanks = function () {
  return $asyncGet(`v3/ServiceProvider/Pay/QueryPersonBanks?service_no=${localStorage.getItem("service_no")}`);
}

/**
 * 通过银行卡号获取开户行
 * v3/wxHelper/apply/QueryOpenBank
 */
export const queryOpenBank = function (accountNo) {
  return $asyncGet(`v3/wxHelper/apply/QueryOpenBank?accountNo=${accountNo}&service_no=${localStorage.getItem("service_no")}`);
}

/**
 * 获取省
 * @returns
 */
export const wxGetBankProvince = function () {
  return $asyncGet(`v3/wxHelper/apply/ListProvinces?service_no=${localStorage.getItem("service_no")}`);
};

/**
 * 获取所有市
 * @param {string} provinceId 省编号
 * @returns
 */
export const wxGetBankCity = function (provinceId) {
  return $asyncGet(`v3/wxHelper/apply/ListCity?provinceId=${provinceId}&service_no=${localStorage.getItem("service_no")}`);
};

/**
 * 获取开户行含支行名称
 * @param {string} branchCode 银行号
 * @param {string} cityCode 市编号
 * @returns
 */
export const wxGetBankCode = function (branchCode, cityCode) {
  return $asyncGet(`v3/wxHelper/apply/GetBankCode?branchCode=${branchCode}&cityCode=${cityCode}&service_no=${localStorage.getItem("service_no")}`);
}

/**
 * 查询微信进件列表
 * @param {number} limit 限制一页多少条
 * @param {number} offset 限制第几页
 * v3/wxHelper/apply/QueryServiceApplyment
 */
export const wxQueryServiceApplyment = function (limit, offset) {
  return $asyncGet(`v3/wxHelper/apply/QueryServiceApplyment?limit=${limit}&offset=${offset}&service_no=${localStorage.getItem("service_no")}`)
}

/**
 * 通过系统店铺id查询店铺的进件记录
 * /v3/wxHelper/apply/QuerMerchantApplymentId
 * @param {string} merchant_id 店铺id
 * @returns 返回系统单号和微信单号
 */
export const wxQuerMerchantApplymentId = function (merchant_id) {
  return $asyncGet(`v3/wxHelper/apply/QuerMerchantApplymentId?merchant_id=${merchant_id}&service_no=${localStorage.getItem("service_no")}`)
}

/**
 * 查询业务状态
 * /v3/wxHelper/apply/QuerySheetApplyment
 * @param {string} sheet_no 系统单据号 只能通过系统单号
 */
export const wxQuerySheetApplyment = function (sheet_no) {
  return $asyncGet(`v3/wxHelper/apply/QuerySheetApplyment?sheet_no=${sheet_no}&service_no=${localStorage.getItem("service_no")}`);
}

/**
 * 查询申请单号状态
 * /v3/wxHelper/apply/QueryApplyment
 * @param {string} applyment_id 微信申请单号 只能通过微信单号
 */
export const wxQueryApplyment = function (applyment_id) {
  return $asyncGet(`v3/wxHelper/apply/QueryApplyment?applyment_id=${applyment_id}&service_no=${localStorage.getItem("service_no")}`)
}

/**
 * 微信进件
 * v3/ServiceProvider/Pay/applywechat
 */
export const wxMchPayApply = function (merchant_id) {
  return $asyncPost(`v3/wxHelper/apply/applyment?service_no=${localStorage.getItem("service_no")}&merchant_id=${merchant_id}`, {});
}
